
import { defineComponent, reactive, ref, toRefs } from 'vue'
import jfschool from '@/api/jfschool'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store'
import { PlayCircleFilled } from '@ant-design/icons-vue'
import Nodata from '@/components/page/nodata.vue'
import Card from './card.vue'
export default defineComponent({
  components: {
    PlayCircleFilled,
    Nodata,
    Card
  },
  setup() {
    type pageDataType = {
      groupsLabelslist: {
        groups: Array<any>
        labels: Array<any>
      }
      selectedlabels?: Array<string>
      selectedgroups?: Array<string> | null
      list?: []
      loading: boolean
    }
    const route = useRoute()
    const pageData: pageDataType = reactive({
      groupsLabelslist: {
        groups: [],
        labels: []
      },
      selectedlabels: [],
      selectedgroups: [''],
      list: [],
      loading: false
    })
    function getGroupsLabels() {
      pageData.loading = true
      const data: any = {}
      data.data = {}
      data.headers = {
        appcode: store.state.pcqueryInfo.appcode
      }
      jfschool.getGroupType(data).then((res: any) => {
        const result = res.data
        result.labels.forEach((item: any) => {
          item.value = item.groupCode
          item.label = item.groupName
        })
        pageData.groupsLabelslist = res.data
        pageData.selectedgroups = [((pageData.groupsLabelslist || {})?.groups[0] || []).groupCode]
        getAllCourse()
      })
    }
    function getAllCourse() {
      const data: any = {}
      const selectedgroups = (pageData.selectedgroups || []).filter((item: any) => item)
      data.data = {
        groupCodes: (pageData.selectedlabels || []).join(','),
        // industryCode: (pageData.selectedlabels || []).join(',')
        industryCode: selectedgroups[0]
      }
      data.headers = {
        appcode: store.state.pcqueryInfo.appcode
      }
      jfschool.getAllCourse(data).then((res: any) => {
        pageData.list = res.data
        pageData.loading = false
      })
    }
    getGroupsLabels()
    function checkechange(e: any) {
      getAllCourse()
    }
    function groupchange(item: any) {
      pageData.selectedgroups = [item.groupCode]
      getAllCourse()
    }
    function gotoCourseDetail(p: { courseNo: any; lessonNo: string }) {
      router.push({
        name: 'coursedetail',
        query: {
          ...route.query,
          courseNo: p.courseNo
        }
      })
    }
    return {
      ...toRefs(pageData),
      checkechange,
      groupchange,
      gotoCourseDetail
    }
  }
})
